"use client"

import { LinkedInLogoIcon, TwitterLogoIcon } from "@radix-ui/react-icons"
import { Session } from "next-auth"
import { signOut } from "next-auth/react"
import Link from "next/link"
import { useRouter } from "next/navigation"

import { useSearch } from "@/hooks/use-search"
import { cn } from "@/lib/utils"

import { Button } from "../ui/button"
import Brain from "../ui/icons/brain"
import Filter from "../ui/icons/filter"
import Reset from "../ui/icons/reset"
import Rocket from "../ui/icons/rocket"
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip"

const items = [
  {
    icon: Rocket,
    text: "Technologies",
    smText: "Techs",
  },
  {
    icon: Brain,
    text: "Features",
    smText: "Feats",
  },
  {
    icon: Filter,
    text: "Other filters",
    smText: "Filters",
  },
]
export default function Navbar({
  session,
  boilerplate,
}: {
  session: Session | null
  boilerplate: { id: string } | null | undefined
}) {
  const router = useRouter()
  const { reset } = useSearch()

  return (
    <>
      {/* <div className="block h-[88px] w-screen shrink-0 2xl:hidden">
        <p></p>
      </div> */}
      <div className="relative z-10 flex flex-col justify-between border-r border-neutral-200 bg-main-bg shadow lg:flex-row lg:p-[20px] 2xl:h-full 2xl:w-[240px] 2xl:flex-col">
        <div className="order-2 flex gap-[10px] p-[20px] lg:order-1 lg:p-0 2xl:flex-col">
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                name="Reset all filters"
                aria-label="Reset all filters"
                onClick={() => {
                  reset()
                }}
                variant="secondary"
                className="group h-[48px] !w-[48px] !p-0"
              >
                <div className="transition-all duration-300 group-hover:scale-110">
                  <Reset />
                </div>
              </Button>
            </TooltipTrigger>
            <TooltipContent>Reset all filters</TooltipContent>
          </Tooltip>

          <div className="flex flex-wrap gap-[0px] sm:flex-nowrap sm:gap-[10px] 2xl:flex-col">
            {items.map((el) => {
              return (
                <NavbarItem
                  key={el.text}
                  smText={el.smText}
                  icon={el.icon}
                  text={el.text}
                />
              )
            })}
          </div>
        </div>
        <div className="order-1 flex justify-end gap-[10px] border-b border-neutral-200 p-[20px] lg:order-2 lg:justify-start lg:border-0 lg:p-0 2xl:flex-col">
          <div className="flex gap-2">
            <Button
              name="LinkedIn"
              aria-label="LinkedIn"
              onClick={() => {
                window.open(
                  "https://www.linkedin.com/in/yannis-haismann-289286192/",
                  "_blank"
                )
              }}
              className="hidden w-fit items-center gap-2 sm:flex"
              variant="secondary"
            >
              <LinkedInLogoIcon className="h-6 w-6 shrink-0" />
            </Button>
            <Button
              name="X (Twitter)"
              aria-label="X (Twitter)"
              onClick={() => {
                window.open("https://x.com/YannisHaismann", "_blank")
              }}
              className="flex w-fit items-center gap-2"
              variant="secondary"
            >
              <TwitterLogoIcon className="h-6 w-6 shrink-0" />
            </Button>
          </div>
          {boilerplate?.id ? (
            <Button
              onClick={() => {
                router.push(`/creator/leads`)
              }}
              variant="default"
            >
              <p>Dashboard creator</p>
            </Button>
          ) : (
            <Button
              onClick={() => {
                if (session) {
                  router.push("/submit")
                } else {
                  router.push("/signin")
                }
              }}
              variant="default"
            >
              <p>Submit a boilerplate</p>
            </Button>
          )}
          {session ? (
            <Button
              onClick={() => {
                signOut()
              }}
              variant="secondary"
            >
              <p>Sign out</p>
            </Button>
          ) : (
            <Link className="w-full" href="/signin">
              <Button className="w-full" variant="secondary">
                <p>Sign in</p>
              </Button>
            </Link>
          )}
        </div>
      </div>
    </>
  )
}

export function NavbarItem({
  icon: Icon,
  text,
  smText,
}: {
  icon: any
  text: string
  smText?: string
}) {
  const { filter, search } = useSearch()
  return (
    <Button
      onClick={() => {
        search({ filter: text })
      }}
      variant="navbar-choice"
      className={cn("flex items-center justify-start gap-2 sm:gap-3", {
        "!bg-neutral-200": filter === text,
      })}
    >
      <Icon />
      <p className="hidden !text-base text-main-black sm:block">{text}</p>
      <p className="block !text-base text-main-black sm:hidden">
        {smText ?? text}
      </p>
    </Button>
  )
}
